module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    staticClass: "chap-num",
    attrs: {
      "id": "ch04"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_61"
    }
  }), _c('span', {
    staticClass: "bold"
  }, [_vm._v("4")])]), _vm._v(" "), _c('h2', {
    staticClass: "chap-title"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("The Preservers")])]), _vm._v(" "), _c('p', {
    staticClass: "h3"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Contributions to Turkey’s Archeology")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("While architecture creates new edifices for a society, archeology attempts to preserve the remnants of cultures past. And while the Ottoman Empire could have rightfully boasted of having had excellent architects, such is not quite the case with archeologists. Yes, the Ottoman "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Dar-ül Fünun")]), _vm._v(" was familiar with archeology. Over the years, its faculty did teach archeology courses. However the Imperial Museum, now known as Istanbul’s Museum of Archeology, founded by the artist and museum director "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Osman Hamdi")]), _vm._v(" and opened to public on June 13 1891 was more informed in this respect than the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Dar-ül Fünun")]), _vm._v(". Archeology was practiced there. Surely Turkey’s republican fathers did not want to live in the past. They found much of their more recent cultural legacy ideologically repugnant. Nevertheless, they were convinced that all history needs to be discovered, preserved, and studied ("), _c('a', {
    attrs: {
      "href": "#/xhtml/12_Chapter04#fig_22"
    }
  }, [_vm._v("Fig. 22")]), _vm._v(").")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Consequently, among the invitees, there were those whose mission would be to develop capabilities to do all this. Clearly, archeology as we know it today was a necessary discipline, but it was not sufficient for accomplishing the mission. This had been dealt with by including among the invitees many broad-gauged scientists who had demonstrated an ability to work both within and across traditional disciplines. The most senior of these were Assyriologist, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Benno Landsberger")]), _c('sup', {
    staticClass: "sup"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/28_Notes#ch4fn1",
      "id": "rch4fn1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("1")])]), _vm._v(" and Hittitologist "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Hans Güterbock.")]), _vm._v(" Many years later, Güterbock wrote that “Landsberger could keep his position in Leipzig because he fought in the front lines for Germany in WWI. Nevertheless in 1935 he was relieved of duties for ‘racial’ reasons.”"), _c('sup', {
    staticClass: "sup"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/28_Notes#ch4fn2",
      "id": "rch4fn2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("2")])]), _vm._v(" Silesian native Benno Landsberger, born in "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Friedek,")]), _vm._v(" Czechoslovakia on April 21 1890, was the son of manufacturer Leopold Landsberger and his wife Hedwig (Hitschmann). He attended the local Gymnasium and, in 1908, entered the University of Leipzig to study Assyriology with Heinrich Zimmern and Arabic with August Fischer. He was drafted at the "), _c('a', {
    attrs: {
      "id": "page_62"
    }
  }), _vm._v("outbreak of WWI. Wounded on the Eastern front, he earned the Golden "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Verdienstkreuz")]), _vm._v(" while fighting in the Ukraine and was discharged in 1918. Landsberger went on to lay the foundations for the study of modern Assyriology, and, with his linguistic capabilities, he succeeded in freeing Assyriology from its dependence on the Arab and Hebrew languages. He attempted to characterize Mesopotamian culture on the basis of language, laws, literature, and economic and social culture rather than depending on the Bible. His genius found expression not only in his linguistic works but also in his penetrating and original analyses of critical questions of Mesopotamian history and chronology. His work in comparative semantics and lexicography hold special significance for Semitic history as well.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Although Landsberger passed away in 1968, decades before the emergence of the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("World Wide Web,")]), _vm._v(" his name pulls up dozens of references in this relatively new medium, and they appear in several languages. Even the Czech Moravians in America take pride in one of their own, Benno Landsberger."), _c('sup', {
    staticClass: "sup"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/28_Notes#ch4fn3",
      "id": "rch4fn3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3")])]), _vm._v(" Many websites discuss his work in Turkey. Landsberger started working in the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Language, History, and Geography")]), _vm._v(" Faculty in Ankara. The Faculty had just been created and this scholar, forty-five at the time, played an active role in its establishment. In 1948, he was invited to teach at the Oriental Institute of the University of Chicago. He taught there until 1955 but continued his scholarly work after retirement. He passed away in Chicago April 26 1968. Hans Güterbock wrote the following of his teacher turned colleague: “Landsberger was a rare breed of scholar and he was the foremost representative of his branch. He had left a lasting impression on his students in Ankara. He concentrated all his energy to his students, to the point of neglecting his own studies; in return, they always maintained their gratitude and attachment to him.”"), _c('sup', {
    staticClass: "sup"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/28_Notes#ch4fn4",
      "id": "rch4fn4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Hans Güterbock")]), _vm._v(" was born May 27 1908, in Berlin. Because his father served as secretary of the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Deutsche Orient Gesellschaft,")]), _vm._v(" young Hans became interested in the languages and cultures of the ancient Near East. At first, he studied Hittitology, which was then an emerging discipline. The deciphering of Hittite records, written in cuneiform script, and the establishment of its place among the Indo-European language family were barely twenty years old at the time. Linguistic training and archaeological skills were essential for mastering the subject. Güterbock grew with the field and made important contributions to understanding this civilization born in Anatolia. He learned the ancient Near Eastern languages, including Sumerian and the Semitic Akkadian (which also used the cuneiform system of writing), on his own. Later, he studied Sumerian and Babylonian cuneiform texts with Benno Landsberger and Hittite with Johannes Friedrich in Leipzig. He received his Ph.D. from Leipzig University in the momentous year 1933. Güterbock was an archaeologist, philologist, "), _c('a', {
    attrs: {
      "id": "page_63"
    }
  }), _vm._v("and historian. Such a combination of disciplines in a single individual is rare in today’s academic community. Current scholars find his greatest influence in the philological area, but he considered himself, and was proud to be, an archaeologist. An archaeologist of the old school, one who was well-versed in reading the inscriptions and tablets that archaeologists uncovered, he was his own epigrapher and was gifted with such keen eyesight that even his teacher, Benno Landsberger, made use of it when a particularly difficult-to-read photo of a tablet needed deciphering. This threefold combination was put to the task of “resurrecting the Hittites,” as he himself described his career in the retrospective essay in "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Civilizations of the Ancient Near East.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("In addition to studying the Hittite cuneifom texts, he made seminal contributions to the decipherment of the Indo-European dialect related to Hittite, known today as the Luwian language. Luwian was written in a unique hieroglyphic script on stone monuments as well as on seals. These seals, edited and interpreted by Güterbock in the two volumes of "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Siegel aus Boghazkoy,")]), _vm._v(" furnished the key to many a “Hittite” hieroglyph. Güterbock recognized early on the threads that connected the Hittite culture to the culture of other early Indo-European groups. With his edition of the myth of "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Kumarbi")]), _vm._v(","), _c('sup', {
    staticClass: "sup"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/28_Notes#ch4fn5",
      "id": "rch4fn5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("5")])]), _vm._v(" he laid the foundations for the comparison of Hurrian mythology with early Greek myths, especially as they are found in the works of Hesiod. Today, classicists take the Eastern influence on Greece for granted.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Güterbock “organized and led major archeological excavations in Anatolia before and during World War II”"), _c('sup', {
    staticClass: "sup"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/28_Notes#ch4fn6",
      "id": "rch4fn6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("6")])]), _vm._v(" and trained the first generation of Turkish Hittitologists and archaeologists. He followed Landsberger to Turkey in 1936. Having spent several seasons over there, Güterbock knew Turkey well. He worked with German excavation teams as epigrapher and archaeologist both. To the very end of his life, he was proud of this double career. His spoken and written Turkish were excellent. He was particularly proud of having written the guide to the Hittite Museum (now the Museum of Anatolian Civilizations) in both German and Turkish. After his Turkish contract was not renewed, Güterbock spent a year as guest lecturer at the Karolina University in Uppsala, Sweden, and followed Landsberger to Chicago. In Chicago, he was asked to teach courses in the history of the ancient Near East, a task he performed dutifully even though the field was not his primary interest. However, by doing this, he did exercise an important influence on young scholars.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("During the latter part of his lifetime, Hans Gustav Güterbock received many honors. Among these was the Tiffany and Margaret Blake Distinguished Service Professor at the University of Chicago award in 1959. He served as president of the American Oriental Society in 1962 "), _c('a', {
    attrs: {
      "id": "page_64"
    }
  }), _vm._v("and of the American Research Institute in Turkey from 1968 to 1977. He was elected to membership in the Bavarian Academy of Sciences, the American Academy of Arts and Sciences, and the American Philosophical Society, and was a corresponding fellow of the British Academy. In 1996, he became the second person to receive the American Oriental Society Medal of Merit in recognition of his lifetime contributions to the field of Hittitology. Established in 1985, the award was designed to be given infrequently and only for work of particularly outstanding quality. Hans Gustav Güterbock died on March 29 2000.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("In 2002, a book was published titled "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Recent Developments in Hittite Archaeology and History: Papers in Memory of Hans G. Güterbock.")]), _vm._v(" The book was edited by University of Chicago professors K. Aslihan Yener and Harry A. Hoffner. The reviews it received speak for themselves. Two are below:")]), _vm._v(" "), _c('div', {
    staticClass: "quote"
  }, [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("(T)he volume is a valuable overview in English of the state of the field and is therefore essential reading for specialists in Anatolian studies and related fields.”")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("— Billie Jean Collins, Emory University, in "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Religious Studies Review")]), _vm._v(" 30/1 January 2004")]), _vm._v(" "), _c('p', {
    staticClass: "noindentt"
  }, [_vm._v("This book collects presentations delivered in 1997 at the Hittite sessions of the American Oriental Society meeting in Miami. It is dedicated to the memory of Hans Gustav Güterbock, whose recent death is a great loss to science. He will be remembered not only for his work but also for his human qualities and his generosity.”")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("— Stefano de Martino, University of Trieste, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("JAOS")]), _vm._v(" 123.4, 2003")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("In addition, the émigré “archeology” team in Turkey included "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Walter Kranz,")]), _vm._v(" classical philology, and "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Fritz Kraus,")]), _vm._v(" Assyriologist and student of "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Benno Landsberger")]), _vm._v(" at the Universität Leipzig, who worked in Turkey from 1937 to 1950 as expert preservationist in the Istanbul Archeological Museum and professor at the University. His Austrian citizenship was revoked by the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Generalkonsulat")]), _vm._v(" in 1942. In 1954, Kraus accepted an invitation from Holland’s University of Leiden.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("According to contemporary Assyriologist/historian Bertrand Lafont, the Istanbul Archaeological Museum is quantitatively much richer than the Louvre in cuneiform tablets dating to the third millennium. The beginnings of the cuneiform tablets collection in Istanbul go back to the creation of the Ottoman Imperial Museum and to the implementation of the Turkish Law on Antiquities of 1883 that claimed for this Museum all the antiquities discovered on the territory of the Ottoman Empire. The first cuneiform tablets reached the Museum in 1890."), _c('sup', {
    staticClass: "sup"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/28_Notes#ch4fn7",
      "id": "rch4fn7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("7")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_65"
    }
  }), _vm._v("It is noteworthy that since the end of the First World War and the subsequent creation of the Turkish Republic, these tablet collections in Istanbul did not increase in numbers. First attempts to classify the tablets took place before 1920. But it was only with the arrival of Fritz Kraus in 1937 that a real inventory and classification work could begin on the museum collections. Kraus dedicated ten years of his life to this job before going to Leiden. He stayed in Istanbul at the same time that Landsberger was teaching in Ankara.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("On the whole, according to Kraus himself, “the number of cuneiform tablets in the Istanbul collection, deriving from 12 different sites, comprises 75,000 exemplars. Of that number, 40,000 tablets and fragments come from the single site of Tello. But we must admit that most of these Tello tablets are today in a fragmentary state, some indeed very small. The reason for this is that theses documents, notably the great number of Tello’s large multiple-column tablets seem to have suffered substantially from the attempts of conservators in the 1930s to preserve them through baking.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("War-time military service at times influences future career choices. While serving the German Army in Istanbul and on the Iraq and Palestine fronts during World War I, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Helmut Ritter")]), _vm._v(","), _c('sup', {
    staticClass: "sup"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/28_Notes#ch4fn8",
      "id": "rch4fn8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("8")])]), _vm._v(" became interested in studying the Orient. Born in "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Hessich-Lichtenau,")]), _vm._v(" Germany, in 1892, Ritter became Professor of Oriental Languages in 1919 at the University of Hamburg. He was a member of that faculty until 1926 when he decided to go to Turkey to buy books for the German Oriental Society. While there, he founded the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("German Archaeological Institute")]), _vm._v(" in Istanbul and served as its Director, and founded the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("International Oriental Society")]), _vm._v(" and published its journal "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Oriens.")]), _vm._v(" In 1935, he became Professor of Arabic, Turkish, and Persian Philology at the University of Istanbul. He stayed in those posts until 1948 when he returned to Germany as professor of Eastern Languages at the University of Frankfurt. After retirement from Frankfurt, he returned to Turkey to continue his research at Istanbul University’s Institute of Oriental Studies."), _c('sup', {
    staticClass: "sup"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/28_Notes#ch4fn9",
      "id": "rch4fn9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("9")])]), _vm._v(" Staying in Turkey while the Nazis reigned in his native land saved his life not only because he was Jewish but also because he was openly homosexual."), _c('sup', {
    staticClass: "sup"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/28_Notes#ch4fn10",
      "id": "rch4fn10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("10")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The numismatic expert at the Istanbul Archeological Museum between 1935 and 1940, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Clemens Bosch,")]), _vm._v(" was forced out from his position at "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Halle/ Saale")]), _vm._v(" University’s Archeological Institute because his wife was not Aryan. So he came to Turkey with wife and five children where he remained until death in 1955. From 1940 to 1955, he was Professor of Ancient History at the University of Istanbul.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The years 1947 and 1948 were bad years for those émigré scholars who studied the ancients but who were not museum-connected. No matter how "), _c('a', {
    attrs: {
      "id": "page_66"
    }
  }), _vm._v("senior they were in the academic community worldwide and regardless of how much they contributed to building Turkish institutions and curricula, most did not get their contracts renewed.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The July 17 1948, edition of "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("ULUS,")]), _vm._v(" a Turkish newspaper, carried an article titled “Our Universities.” The article said:")]), _vm._v(" "), _c('div', {
    staticClass: "quote"
  }, [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("The budget for our students has been enlarged. This has been achieved by cutting down on the expenses of foreign professors.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("The tenure of these professors has been terminated in order to confirm our entrenchment:")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Prof. Landsberger: Sumerian studies")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Prof. Güterbock: Hittitology")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Prof. Eberhard: Sinology")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Prof. Halasi-Kuhn: Hungarian studies")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Prof. Ruben: Hindology")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Lecturer: Eckman")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Except for "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Halasi-Kuhn,")]), _vm._v(" who returned to Hungary, and Lecturer "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Eckman,")]), _vm._v(" ultimately the rest found a good home in the West and continued to flourish. The worthiness of these men’s achievements to society is clearly visible and justifiably appreciated.")]), _vm._v(" "), _c('p', {
    staticClass: "h3"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Introducing Library Science, Librarianship, and Document Preservation")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("The work of the archivist and the librarian is just as important as that of the archeologist. However, librarians are not accorded the respect or the salaries they deserve. This very book could not have passed the idea stage were it not for a score or more of archivists and librarians spread over three continents. More globally, for many excellent reasons, a modern society’s need for such experts was not neglected by those representing Ankara in Basel, Switzerland, in 1933. "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Philipp Schwarz")]), _vm._v(" did collect a team of expert librarians, archivists, document preservators, and bookbinders. All these conservators of knowledge and wisdom that had been gathered by generations past and present were ready and willing to oblige. The opportunity presented them was literally a gift of life. They knew it all too well.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“The German librarians...contributed greatly to the organization of a modern European university system in Turkey,” according to German library scientist Hildegard Müller, writing in the highly regarded University of Texas Press journal, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Libraries & Culture.")]), _vm._v(" “From a mere quantitative "), _c('a', {
    attrs: {
      "id": "page_67"
    }
  }), _vm._v("point of view, this emigration to Turkey certainly does not rank first, but seen from a qualitative point of view, that is, the importance it had for their country of adoption, it is surely the case that it was of primary importance.”"), _c('sup', {
    staticClass: "sup"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/28_Notes#ch4fn11",
      "id": "rch4fn11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("11")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Among the senior members of the library contingent was "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Walter Gottschalk.")]), _vm._v(" He was born in 1891 in Aachen and studied orientalism, philosophy, history, and the history of art in Wurzburg and Berlin. He was granted a Ph.D. in 1914. In 1916, Gottschalk was drafted to serve Germany in WWI. His postings were in Turkey, Syria, and Palestine. At war’s end in 1919, he joined the staff of the Prussian State Library in Berlin as senior librarian for language and history of the Middle East. Gottschalk made significant contributions in establishing that library’s Oriental Department. Specifically, he organized the department’s reference library and a precise catalogue. His work was acknowledged by a major promotion in 1923. However, in 1935, he was dismissed because of Jewish origins and forced into retirement. He managed to find work in the field of science and give lectures such as introduction to Arabic.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("By February 1939, he had to leave Germany altogether and he went to Belgium to stay with relatives. While in Belgium, Gottschalk served as a personal go-between for Albert Einstein himself, primarily for the purpose of funneling small monthly stipends from America to Einstein’s relatives who were left behind in Nazi Germany. These days we might call it money laundering. Then, in May 1940, the Germans occupied Belgium and Gottschalk started once again to look for escape alternatives. In 1941, he came to Turkey where he was asked to work for Istanbul University as an expert on library matters. Connected with this was the supervision of all the libraries in the various university institutes. He also “played a prominent part in the development of the Turkish library system....”"), _c('sup', {
    staticClass: "sup"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/28_Notes#ch4fn12",
      "id": "rch4fn12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("12")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("From approximately 1949 onward, Gottschalk held a chair of Library Science at Istanbul University. Gottschalk lived in Istanbul until his retirement in 1954. He then returned to Germany and settled in Frankfurt. After Gottschalk’s departure, the chair in Library Science at Istanbul University was awarded to his assistant, Dr. "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Rudolf Juchhoff")]), _c('sup', {
    staticClass: "sup"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/28_Notes#ch4fn13",
      "id": "rch4fn13",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("13")])]), _vm._v(" who held it until 1968 and was succeeded by Meral Alpay, a Turkish native and an assistant to Dr. Juchhoff.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The senior librarians who emigrated to Turkey were joined by junior colleagues, bookbinders, and restorers. In particular, these skilled and well-trained refugees constructed corresponding bookbinding and restoration departments, and it is to their credit that many Turkish scholars and pupils would be trained. In so doing, the émigrés helped to conserve cultural riches accumulated throughout the Ottoman period and some preceding it. Their efforts made such documents and artifacts "), _c('a', {
    attrs: {
      "id": "page_68"
    }
  }), _vm._v("accessible for all future generations. Also among the German-speaking librarians brought to Turkey was an Austrian, Dr. "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Joseph Stummvoll.")]), _vm._v(" Unlike Gottschalk, Stummvoll worked as librarian at the newly founded "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Yuksek Ziraat Enstitusu,")]), _vm._v(" (University for Agriculture and Veterinary Science) in Ankara. While there, he contributed a number of articles on library systems and conducted many training courses for Turkish librarians outside of Istanbul, Turkey’s most developed and cosmopolitan city then and now.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Dr. "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Max Pfannenstiel was")]), _vm._v(" born in Alsace in 1902. After his studies in geology and mineralogy, he worked at the University library in Freiburg and from 1930 to 1932 at the Bavarian State Library in Munich, where he sat for his qualifying examinations. In January 1933, he returned to the University library in Freiburg and, in August of that same year, he was deemed “non-Aryan.” Although the director of his library, Josef Rest, interceded with the Ministry of Education, pointing out that Pfannenstiel was only part-Jewish (his grandfather on his mother’s side was a Jew), he was nevertheless dismissed on October 12 1933. Unemployed, he looked for work that would present some scientific attributes. From January 1934 to March 1935, he worked in a medical bookshop. Following that, he received a small grant from the “Society of German Natural Scientists and Doctors” to concentrate on various estates. Finally, in February 1935, he managed to obtain a Rockefeller Scholarship and a modest librarian position with the League of Nations in Geneva. While there, he built up that Library’s medical department."), _c('sup', {
    staticClass: "sup"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/28_Notes#ch4fn14",
      "id": "rch4fn14",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("14")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("As it turns out, on January 19 1938, the Turkish Minister of Science and Education wrote to his colleague in "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Baden")]), _vm._v(" that the Director of Libraries position at the University of Agriculture and Veterinary Science in Ankara was vacant. Through the German embassy, the Minister had heard that Pfannenstiel was interested in that position. The embassy, however, advised that, “it is not in the interest of Germany, for political-cultural reasons, that Dr. Pfannenstiel be given this job in Ankara.” Germany’s official position on the matter notwithstanding, on April 15 1938, Pfannenstiel became Library Director at the University of Agriculture and Veterinary Science in Ankara. It did not take long for him to start researching Turkey’s geological formations and writing articles on the subject.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("From 1940, Pfannenstiel worked for "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Türk Tarih Kurumu")]), _vm._v(", the Turkish Historical Society, where he catalogued Atatürk’s library that was bequeathed to the Society."), _c('sup', {
    staticClass: "sup"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/28_Notes#ch4fn15",
      "id": "rch4fn15",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("15")])]), _vm._v(" Pfannenstiel’s contract with the Turkish government ended in August of 1941 and, due to political and wartime pressures, was not renewed. Pfannenstiel never gave up his contacts with Freiburg University’s Library and unlike his fellow émigrés, at all times he looked for a way to return to a German library, under a loophole in the civil service law.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_69"
    }
  }), _vm._v("On June 16 1939, he had actually applied through the German embassy in Ankara. Josef Rest, Freiburg’s Library Director, unconditionally supported his former staff member’s return. Other former colleagues reacted similarly except for one; at the time and in Germany “highly esteemed” Herr Dr. Professor "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Julius Ludwig Wilser")]), _vm._v(" the sitting Director of Heidelberg University’s Geological-Palaeontologic Institute. He can be quoted as writing the following about Dr. Max Pfannenstiel his former University of Freiburg colleague.")]), _vm._v(" "), _c('div', {
    staticClass: "quote"
  }, [_c('p', {
    staticClass: "noindent"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("A Jew remains a Jew!")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("And further, he was part of a decidedly Jewish set in Freiburg, which had had a hostile attitude toward National Socialism. Even if Dr. Pfannenstiel tried to change himself inwardly and outwardly, he remains by blood a half-Jew and does not belong to a community whose aim it is to fulfill the mission set for us by the Fuhrer. German civil servants are brothers-in-arms of Adolf Hitler!"), _c('sup', {
    staticClass: "sup"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/28_Notes#ch4fn16",
      "id": "rch4fn16",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("16")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("This is just one example of what happened at Heidelberg, until then among the world’s premiere universities. In a matter of months, if not weeks, following passage of the Civil Service Law in 1933, it, too, had been Nazified, and taken over by the likes of "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Ludwig Wilser.")]), _vm._v(" Sadly, Heidelberg was not the only previously great German university to become so politicized, nor was Herr Dr. Professor Julius Ludwig Wilser the only academic who jumped on the Nazi’s bandwagon and beat their drums. As will be shown some Nobel laureates acted no differently than did Wilser.")]), _vm._v(" "), _c('div', {
    staticClass: "quote"
  }, [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("The conduct of German intellectuals—seen as a group—was no better than that of the mob.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("—Albert Einstein, January 28, 1949. Letter to Otto Hahn, Einstein Archive 12-072.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Pfannenstiel returned to Germany and, using the law’s loophole, he again became a German civil servant. Pfannenstiel worked in the Erlangen University library until 1947 at which time he was offered a geology chair in Freiburg, and, in 1954, became chancellor of that university. In 1976, he died in Freiburg."), _c('sup', {
    staticClass: "sup"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/28_Notes#ch4fn17",
      "id": "rch4fn17",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("17")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Adding to the above contributions, “In 1935, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Helmut Ritter,")]), _vm._v(" Oriental scholar, at the University of Istanbul set up a ‘library expertise’ in his function as president of a reform commission.”"), _c('sup', {
    staticClass: "sup"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/28_Notes#ch4fn18",
      "id": "rch4fn18",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("18")])]), _vm._v(" So there is no question that the German-speaking professors advanced libraries and librarianship in Turkey. They achieved this through donating their own books, arranging for book and document donations from American and British "), _c('a', {
    attrs: {
      "id": "page_70"
    }
  }), _vm._v("universities, through public lectures, in-residence workshops, expansion of old and creation of new institutes, publication of modern style manuals, and launching of scientific journals. These are some of the prerequisites for teaching and doing scientific work.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("These émigré senior librarians, their junior colleagues, and the restoration experts, created several facilities for document restoration and bookbinding in both Istanbul and Ankara. Not only did these men and women do their jobs well, but they also taught the next generation and generously shared their skills and their knowledge.")]), _vm._v(" "), _c('p', {
    staticClass: "h3"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Translating the Classics of Western Literature into Turkish and Introducing Philology")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("In the early 1930s, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Georg Rohde")]), _vm._v(" and "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Hasan-Ali Yücel,")]), _vm._v(" the Turkish Minister of Education, organized a monumental program for translating the major works of classical (Greek and Roman) and general European literature into the Turkish language. Between 1940 and 1950, no fewer than 76 literary works were translated from German as part of this program, 180 from French, 46 from English, 64 from Russian, and 13 from Italian. Moreover, 28 major works were translated from Latin, 76 from Ancient Greek, and 23 from Persian and Arabic."), _c('sup', {
    staticClass: "sup"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/28_Notes#ch4fn19",
      "id": "rch4fn19",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("19")])]), _vm._v(" They were published by the Turkish Ministry of Education"), _c('sup', {
    staticClass: "sup"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/28_Notes#ch4fn20",
      "id": "rch4fn20",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("20")])]), _vm._v(" and remain in print to this very day.")]), _vm._v(" "), _c('div', {
    staticClass: "quote"
  }, [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("There was no philology; in this country, we kept going on to Osman Hamdi all the time. (Osman Hamdi, founder of the Imperial Museum, also a painter, etc.) He knew neither Semitic languages, nor Greek, nor did he know epigraphy. These are very important subjects that were first looked at in the 1930s. Today, Turkey is a country that has a say in the areas of Assyriology and Sumerology. Some Turkish specialisits, those of our generation and even younger, are pioneer Hittitologists. All this was not possible before 1933. That someone would be able to sit down and read Assyrian texts in this country, this was impossible. Then of course, another important development was the initiation of classical philology. Rohde came and started Latin and Greek."), _c('sup', {
    staticClass: "sup"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/28_Notes#ch4fn21",
      "id": "rch4fn21",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("21")])]), _vm._v(" In addition to translating the classics, Rohde and his students also published a number of Latin texts for use at the secondary school level.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Georg Rohde was born in Berlin in 1899. He had been appointed Privat Dozent at Marburg University in 1931 where he taught classic philology. Relieved of duties because his wife was Jewish, he came to Turkey "), _c('a', {
    attrs: {
      "id": "page_71"
    }
  }), _vm._v("in 1935 and was appointed Professor of Philology of Ancient Languages at Ankara University. In that capacity, he taught the famous Turkish archaeologist and author, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Ekrem Akurgal,")]), _vm._v(" in addition to training a generation of philologists"), _c('sup', {
    staticClass: "sup"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/28_Notes#ch4fn22",
      "id": "rch4fn22",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("22")])]), _vm._v(" before leaving for West Germany in 1949 ("), _c('a', {
    attrs: {
      "href": "#/xhtml/12_Chapter04#fig_23"
    }
  }, [_vm._v("Fig. 23")]), _vm._v(")."), _c('sup', {
    staticClass: "sup"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/28_Notes#ch4fn23",
      "id": "rch4fn23",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("23")])])]), _vm._v(" "), _c('div', {
    staticClass: "quote"
  }, [_c('p', {
    staticClass: "noindent"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Erich Auerbach’s")]), _vm._v(" “work is a strikingly successful combination of philology, stylistics, history of ideas, and sociology, of meticulous learning and artistic taste, of historical imagination, and awareness of our own age.”"), _c('sup', {
    staticClass: "sup"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/28_Notes#ch4fn24",
      "id": "rch4fn24",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("24")])])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("German philologist, educator, critic, and literary historian Erich Auerbach was born in Berlin into an upper-middle class Jewish family in 1892. He studied at the universities of Berlin, Freiburg, and Munich. In 1913, Auerbach received a Doctor of Law degree from the University of Heidelberg. During the First World War, he served in Germany’s army. After the war, Auerbach changed disciplines and received a Ph.D. in Romance philology from the University of Greifswald in 1921. Between 1923 and 1929, he was librarian at the Prussian State Library in Berlin, and, in 1929, he went on to become professor of Romance philology at the University of Marburg.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("In Marburg, Auerbach gained recognition with his work, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Dante: Poet of the Secular World")]), _vm._v(" (1929). Dismissed in 1935, he went to Istanbul where he taught at Istanbul University until 1947. During his years in Turkey, Auerbach wrote his famous work, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Mimesis,")]), _vm._v(" which was first published in German in 1946 and seven years later in English. It represents an account of the genesis of the novel. Since its appearance, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Mimesis")]), _vm._v(" has been among the most widely read scholarly works on literary history and criticism. The famous Harvard scholar Edward Said provides the following interpretation on the genesis of "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Mimesis:")])]), _vm._v(" "), _c('div', {
    staticClass: "quote"
  }, [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("The book owed its existence to the very fact of Oriental, non-Occidental exile and homelessness. And if this is so, then "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Mimesis")]), _vm._v(" itself is not, as it has so frequently been taken to be, only a massive reaffirmation of the western cultural tradition, but also a work built upon a critically important alienation from it, a work whose conditions and circumstances of existence are not immediately derived from the culture it describes with such extraordinary insight and brilliance but built rather on an agonizing distance from it."), _c('sup', {
    staticClass: "sup"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/28_Notes#ch4fn25",
      "id": "rch4fn25",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("25")])])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Regarding the limited European studies collections of Istanbul libraries at the time and not having access to all the literature he needed, Auerbach quipped, “On the other hand, it is quite possible that the book owes "), _c('a', {
    attrs: {
      "id": "page_72"
    }
  }), _vm._v("its existence to just this lack of a rich and specialized library. If it had been possible for me to acquaint myself with all the work that has been done on so many subjects, I might never have reached the point of writing.”"), _c('sup', {
    staticClass: "sup"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/28_Notes#ch4fn26",
      "id": "rch4fn26",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("26")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Two smaller studies dating from this period appeared in Finland’s "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Neuphilologische Mitteilungen")]), _vm._v(" journal. In 1947, Auerbach moved to the United States. He taught at Pennsylvania State University and was a member of the Institute for Advanced Study at Princeton before being appointed Professor of Romance philology at Yale University in 1950. Auerbach died in Wallingford, Connecticut, on October 13 1957, but his writings are still being taught worldwide to all those who seek a well-rounded education."), _c('sup', {
    staticClass: "sup"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/28_Notes#ch4fn27",
      "id": "rch4fn27",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("27")])])]), _vm._v(" "), _c('p', {
    staticClass: "h3"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Making Turkology an Academic Discipline in Turkey")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Andreas Tietze,")]), _vm._v(" world-renowned Turkologist, was born in Vienna on April 26 1914. The son of prominent art historians Hans Tietze and Erica Conrad-Tietze, he studied history and languages at the University of Vienna starting 1932 and received his doctorate in 1937 - for Austria, a year of note. A diary "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("(Unsere")]), _vm._v(" und "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Die Zweite Anatolienreise)")]), _vm._v(" kept by one of his companions concerning two trips that Tietze made to Anatolia between 1936 and 1937 with "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Robert Anhegger,")]), _vm._v(" remains one of perhaps just two firsthand accounts by foreign visitors of life as lived in the countryside outside of Istanbul and Ankara in those early days of the Turkish Republic. A photocopy of Tietze’s diary now resides in the archives of the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("International Institute of Social History")]), _vm._v(" in Amsterdam.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("At the time of Austria’s Anschluss, Tietze moved to Istanbul. There he was a Lecturer in German from 1938 to 1952 and a Lecturer in English from 1953 to 1958. In addition to his teaching, he was the editor of a series of 16 titles, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Istanbuler Schriften,")]), _vm._v(" that included his first reader for foreign students of Turkish, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Türkisches Lesebuch für Auslaender")]), _vm._v(" (Istanbul, 1943), written jointly with "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Sura Lisiev.")]), _vm._v(" Tietze was also active in the field of folklore as co-editor and contributing translator on the orientalist, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Helmut Ritter’s")]), _vm._v(" monumental three-volume study of Turkey’s shadow puppet theater, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Karagöz: Türkische Schattenspiele")]), _vm._v(" (Hanover, 1924-53). It was during this time that he became deeply involved in lexicography. He prepared a Turkish-German dictionary "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("(Türkçe-Almanca Sözlügü)")]), _vm._v(" with Ritter, and, from 1946 to 1958, he directed the American Board Publication Office project involving the revision of the original "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Redhouse English-Turkish Dictionary")]), _vm._v(" of 1861 and the companion "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Redhouse Turkish-English Dictionary")]), _vm._v(" of 1890. Both works, now further updated, remain indispensable to students of Turkish and vice versa of Turks studying English.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("With the scholars Henry and Renée Kahane, Tietze also co-authored an etymological dictionary of Turkish nautical terms of Italian and Greek origin, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("The Lingua Franca in the Levant")]), _vm._v(" (University of Illinois Press, 1958). "), _c('a', {
    attrs: {
      "id": "page_73"
    }
  }), _vm._v("This work aimed to demonstrate the linguistic-cultural unity of the Mediterranean area. In 1958, he came to UCLA and is considered “one of the founders of Turkic studies in the United States.” “Professor Tietze was best known for his contributions to Turkish lexicography, his work on Turkish riddles and Turkish "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Karagöz")]), _vm._v(" (Blackeye) plays, his editions and translations of Ottoman works, and his founding and editorship of an annual bibliography covering all aspects of Turkish and Ottoman life. He was also a translator of modern fiction, from German to Turkish, Turkish to German, and Azerbaijani to Turkish”"), _c('sup', {
    staticClass: "sup"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/28_Notes#ch4fn28",
      "id": "rch4fn28",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("28")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("While at UCLA, Professor Tietze authored numerous scholarly articles and continued his research on folklore. Comparing the oldest collection of Turkish riddles, those found in a section of the 14th-century document known as the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Codex Cumanicus,")]), _vm._v(" (a Latin guide to the Cuman tongue) with related riddles from other Turkic sources, he described a new vision of this early codex in "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("The Koman Riddles and Turkic Folklore")]), _vm._v(" (University of California Press, 1966). With the folklorist "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Ilhan Basgöz,")]), _vm._v(" he compiled "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Bilmece: A Corpus of Turkish Riddles,")]), _vm._v(" a large collection of the genre based on the efforts of several leading scholars (University of California Press, 1973). With his colleague, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Avedis K. Sanjian,")]), _vm._v(" Professor of Armenian, he edited "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Eremya Chelebi Kömürjian’s Armeno-Turkish Poem “The Jewish Bride”")]), _vm._v(" (Budapest, 1981), a 17th-century work significant for its revelations about the Turkish spoken in Istanbul in the second half of that century and about the relations between the different religious communities in the turbulent period following the appearance of the self-styled Jewish Messiah, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Sabbatai Sevi.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Throughout his tenure at UCLA, Professor Tietze was instrumental in building up the Turkish and Ottoman books and manuscripts collections at the Young Research Library. By making it one of the largest repositories of such works in the United States, Tietze enabled America’s young scholars to learn about Turkey’s cultural heritage."), _c('sup', {
    staticClass: "sup"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/28_Notes#ch4fn29",
      "id": "rch4fn29",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("29")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Professor of Roman and Comparative Philology at Cologne University "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Leo Spitzer")]), _vm._v(" was released in 1933 for the usual and customary reasons. During that year, he was offered the position of Professor of Roman Languages and Literatures at Istanbul University. There he was first to introduce courses on philology and to establish the university’s School of Foreign Languages. When he re-emigrated to the US in 1936 with a job at Baltimore’s prestigious Johns Hopkins University, his institution-building work was taken on by "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Erich Auerbach.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Recently retired Turkish professor "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Aykut Kazancigil,")]), _vm._v(" a physician and translator of several books into Turkish, including the one on émigré professors by Horst Widman, wrote the following about "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Wolfram Eberhard:")]), _vm._v(" He “had about 689 publications. I collected all of these and included them in my new book "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Chinese Symbols.")]), _vm._v(" For example, he liked "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Halit Ziya")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "page_74"
    }
  }), _vm._v("[Usakligil, A Turkish author of fiction] a lot. He published the Journal of Sociology in Germany. He even made "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Sait Faik")]), _vm._v(" [Abasiyanik, writer of very modern stories] a known name in America. Yes, these men created a scientific whirlwind in Turkey. It can be asked what is our gain from them. Under no conditions will I say that it was negative. We benefited from them as much as we were able to.”"), _c('sup', {
    staticClass: "sup"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/28_Notes#ch4fn30",
      "id": "rch4fn30",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("30")])]), _vm._v(" However, Eberhard’s contract was not renewed in 1948. He joined the University of California and shifted from sinology to sociology. “The change was not as drastic as it appears, for Eberhard had always been interested in the sociological aspects of Chinese culture. As a sinologist he stressed cultural factors, and as a sociologist he drew examples from Chinese societies.”"), _c('sup', {
    staticClass: "sup"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/28_Notes#ch4fn31",
      "id": "rch4fn31",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("31")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Thus, well over four centuries after the Jews exiled from Spain introduced the first printing press to the Ottoman Empire,"), _c('sup', {
    staticClass: "sup"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/28_Notes#ch4fn32",
      "id": "rch4fn32",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("32")])]), _vm._v(" Jewish refugees from fascism were instrumental in introducing philology, making Turkology an Academic Discipline in Turkey, and having a large body of western thought translated into Turkish and printed using the newly created Turkish alphabet. However, the translations program flew in the face of the prevailing Turkish nationalist fervor. Consequently, 1941 to date, every edition of every translated book published by the Education Ministry has in its Foreword "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Hasan-Ali Yücel’s")]), _vm._v(" argument that “the wealthier a nation’s library of translations is, the higher its status among the nations of the civilized world.” "), _c('sup', {
    staticClass: "sup"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/28_Notes#ch4fn33",
      "id": "rch4fn33",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("33")])])]), _vm._v(" "), _c('p', {
    staticClass: "h3"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Introducing Botany and Zoology as Research Disciplines and as Conservation Professions")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("While working in West Anatolia, zoologist "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Curt Kosswig")]), _vm._v(" discovered an area at the edge of Lake "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Manyas")]), _vm._v(" that is now known as "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Kuş Cenneti")]), _vm._v(" (Birds’ Heaven). It is a nesting location of major importance for migratory birds. He also discovered the area in "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Birecik")]), _vm._v(" where the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Kelaynak")]), _vm._v(" (bald ibis) birds nest. These finds are widely considered to be of worldwide importance. Subsequent work by Kosswig and his wife, Leonore, was instrumental in having Lake Manyas declared a national and international nature preserve. The “Birds’ Heaven” is one of the most important worldwide natural reserves for migratory birds and for wildfowl."), _c('sup', {
    staticClass: "sup"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/28_Notes#ch4fn35",
      "id": "rch4fn35",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("35")])]), _vm._v(" Additionally, through the efforts of Professor Kosswig, the Institute of Hydrobiology at "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Baltalimani,")]), _vm._v(" a part of the Faculty of Science, was established in 1950 ("), _c('a', {
    attrs: {
      "href": "#/xhtml/12_Chapter04#fig_24"
    }
  }, [_vm._v("Fig. 24")]), _vm._v(" and "), _c('a', {
    attrs: {
      "href": "#/xhtml/12_Chapter04#fig_25"
    }
  }, [_vm._v("25")]), _vm._v(").")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The émigré botanists and zoologists proved to be as much conservators of Nature’s treasures as they were scientists trying to understand her secrets. In 1935, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Andre Neville")]), _vm._v(" together with Botanist Prof. Dr. "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Alfred Heilbronn")]), _vm._v(" and Prof. Dr. "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Leo Brauner")]), _vm._v(" established Turkey’s first Zoology Museum. It was initially located on the same floor as the zoology department within "), _c('a', {
    attrs: {
      "id": "page_75"
    }
  }), _vm._v("the Faculty of Science building. Some birdcages and singing birds were brought from the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Yildiz")]), _vm._v(" Palace in Istanbul. Others were obtained as gifts from France and Germany."), _c('sup', {
    staticClass: "sup"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/28_Notes#ch4fn36",
      "id": "rch4fn36",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("36")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("While practicing preservation of Nature’s treasures, Professor Curt Kosswig also made significant contributions to medical science. If a cure for cancer is ever found, one of Kosswig’s discoveries will have played a role. Justus Liebig is on record in the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Genetisches Institut")]), _vm._v(" that “modern cancerology is based on the oncogene concept. This is rather new. The idea of the oncogene, however, is old, and can be traced back to two sources, namely to ‘cancer families,’ reported in 1866 by P. Broka, and to ‘virus-induced’ neoplasia, detected by P. Rous in 1911.” Liebig goes on to say that to the best of his knowledge “a gene which is the first reported oncogene by definition was detected in the little ornamental Mexican fish Xiphophorus by Myron Gordon, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Curt Kosswig,")]), _vm._v(" and Georg Haussler in 1928 when they observed the terrible hereditary melanomas "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("that we are now coming to understand and compare with other kinds of neoplasms in Xiphophorus and in mammals, including humans.")]), _vm._v(" Although the Xiphophorus model was always modest in its claims, it has—sometimes too early in its history–contributed many facts to the present concept of neoplasia.”"), _c('sup', {
    staticClass: "sup"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/28_Notes#ch4fn37",
      "id": "rch4fn37",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("37")])]), _vm._v(" (emphasis added)")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("During Kosswig’s sojourn in Turkey, he was widely considered to be the leading, if not the only, scientific authority for zoology in the country and he greatly enlarged the collections of its Zoological Museum. But Kosswig’s contributions ranged beyond zoology and conservation. An educator, he proved to be a skilled administrator and institution builder, and, as a man of conviction, he acted as a cross-regional diplomat on behalf of science. He served in Turkey between 1937 and 1954.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("His scientific achievements were broad and deep. While researching the various cancer indicators found in a given species of fish, he created a taxonomic approach to zoology and encouraged its use and expanded applications. A geneticist and zoologist, his most important scientific contributions are in mechanisms of sex determination, carcinogenesis, regressive and constructive evolution, the genetics of domestic animals, faunal history, zoogeography, and the rarely mentioned field of "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("systematics.")]), _vm._v(" Kosswig’s ideas and concepts as well as the results of his research are indeed of crucial importance to "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("biological systematics.")]), _vm._v(" As part of his tribute to Kosswig, German Professor Wolfgang Villwock pointed out that “scientific answers to questions posed in the specialized disciplines” of zoogeography and faunal history, require a “comprehensive and detailed analysis of faunal diversity based on a reliable phylogenetic taxonomic system.”"), _c('sup', {
    staticClass: "sup"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/28_Notes#ch4fn38",
      "id": "rch4fn38",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("38")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("In 1932, Kosswig took the “Extraordinariat” for Zoology at the "), _c('a', {
    attrs: {
      "id": "page_76"
    }
  }), _vm._v("Technical University of Braunschweig and a year later was appointed director of the Natural History Museum in that city. After 1933, he refused to dismiss Jewish employees and to sever relations with scientists and friends forced to emigrate. Eventually, he himself felt threatened and had to flee Braunschweig. Kosswig emigrated to Turkey in 1937. Shortly after being appointed Professor of Zoology in the fall of 1937, he mastered the Turkish language and lectured future biologists and medical doctors on the foundations of natural science. He published several textbooks in Turkish for both university and high school students. One of these books went through five revised and upgraded editions. He founded the magazine “"), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Bioloji”")]), _vm._v(" aimed at the general public. Besides enlarging the Institute of Zoology, in 1950, Kosswig established the Institute of Hydrobiology that became a center for fisheries research. Eventually a seagoing research vessel was acquired as well. Perhaps the best example of his scientific drive and his diplomatic skill was his success, in spite of strong (political) tensions after the second World War, to forge cooperation and to extend research on the zoogeography of Anatolia to the entire Near East. Kosswig received the “Distinguished Service Medal” from the Federal Government of Germany and a similar medal in 1981 from the Government of Turkey on the occasion of Atatürk’s 100th birthday")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("During the course of a 2001 Istanbul aquaculture development workshop, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Isik Oray,")]), _vm._v(" a Turkish native, and "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Harald Rosenthal,")]), _vm._v(" a German, reminisced about their graduate studies at Hamburg University and instructors they had had in common. It dawned on them that the 20th anniversary of their beloved Professor Kosswig’s death was but a few months away. The idea to honor him was born there and then. The occasion envisaged should stress “the achievements of this outstanding science teacher and internationally widely recognized scientist jointly with his former Turkish and German students.”"), _c('sup', {
    staticClass: "sup"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/28_Notes#ch4fn39",
      "id": "rch4fn39",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("39")])]), _vm._v(" A quick, albeit informal, opinion survey of Turkish colleagues who were also former Kosswig students about organizing a joint Memorial Symposium to be held in Turkey was well received. Back in Germany, Rosenthal presented a proposal to "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Wolfgang Villwock")]), _vm._v(","), _c('sup', {
    staticClass: "sup"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/28_Notes#ch4fn40",
      "id": "rch4fn40",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("40")])]), _vm._v(" Kosswig’s student in Hamburg, to serve as co-chair of the Symposium along with Isik Oray. Villwock accepted. The Symposium was to serve the entire zoological science community in Turkey as well as attract former Kosswig students from throughout the world albeit predominantly from Germany and Austria. Because of logistical problems, however, it was decided to celebrate the 100"), _c('sup', {
    staticClass: "sup"
  }, [_vm._v("th")]), _vm._v(" anniversary of Kosswig’s birthday—in Istanbul during October 2003. Cosponsors of the event were the Hamburg Zoological Museum and Institute,"), _c('sup', {
    staticClass: "sup"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/28_Notes#ch4fn41",
      "id": "rch4fn41",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("41")])]), _vm._v(" University of Hamburg, and the University of Istanbul. “In October 2003, more than twenty German colleagues, and students,” as well as several of Kosswig’s “quasi-scientific grandchildren” "), _c('a', {
    attrs: {
      "id": "page_77"
    }
  }), _vm._v("traveled to Istanbul to jointly celebrate this special event with their Turkish counterparts."), _c('sup', {
    staticClass: "sup"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/28_Notes#ch4fn42",
      "id": "rch4fn42",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("42")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The symposium proceedings were published in 2004 by the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Hamburg Zoological Museum and Institute.")]), _vm._v(" In addition to having twenty refereed scientific papers, there are also three testimonial and/or biographical contributions. There is a three-page foreword by Villwock in German. He also has a shorter version in English. There is the official Memorial speech by Professor Fischer-Appelt. Some part of his speech deals with the general scientific and cultural climate in Turkey before 1933. And there is a paper by Professor "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Michael Dzwillo")]), _vm._v(" on “The relevance of Curt Kosswig’s scientific achievements to systematic zoology.” Written in English, it shows that while in Turkey, Kosswig did a great deal of work on zoogeography of cyprinodontid fishes (killifishes, pupfishes, and toothcarps) of Anatolia.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Kosswig, while in Turkey, also expanded his fields of scientific inquiry to include the faunal history and biogeography of Anatolia and the Middle East. He particularly focused on species of freshwater fish in an area of overlapping bio-geographical regions. Kosswig’s studies of cyprinodontids of Anatolia turned out to be especially valuable because they yielded results the relevance of which extended far beyond regional faunal problems. Based on these investigations into cyprinodontids, Kosswig initiated a substantial research program into the faunal history and biogeography of the entire Middle East. Understandably, a project of this scale was beyond the capacities of a single group to tackle. Only international cooperation with competent experts promised to disentangle the complexities of the zoogeography and faunal history of the Middle East. At this point, Kosswig skillfully demonstrated his talents for encouraging specialists of important taxa to contribute to the investigation of the local fauna that is characterized by elements of different faunal regions.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Thanks to his academic reputation and his diplomatic talents, Kosswig, in 1951, managed to organize a UNESCO-funded international symposium on zoogeography of the Middle East at University of Istanbul’s hydro-biological institute (UNESCO 1954) which had only recently been founded by him. Even in those days of high political tension, Kosswig succeeded in initiating fruitful cooperation and stimulating exchange of ideas between zoologists from Turkey, Israel, Egypt, Iraq, and Lebanon as well as from Italy and England. In the years and decades following this symposium, Kosswig collected comprehensive zoological material of many different taxa and, together with precise data on the exact localities of collection, passed it on to specialists and museums of natural history for systematic research.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("In 1950, Kosswig described some new "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Teleost")]), _vm._v(" species. It is also worth noting that he supported researchers from different countries while "), _c('a', {
    attrs: {
      "id": "page_78"
    }
  }), _vm._v("collecting and working in Turkey. Many general species and subspecies were named after Kosswig, thus demonstrating the degree to which his contributions were appreciated by zoologists in the field of systematics. Among these are: Kosswigius Verhoeff,1941 Isopoda, Kosswigichthys Sozer, 1942 Cyprinodontidae, Kosswigia Jeannel, 1947 Coleoptera, Kosswigibilis Chamberlin, 1952 Chilopoda, and Kosswigianella Wagner, 1962.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Curt Kosswig felt especially attached to Turkey. In a short time, he learned the language very well. And he returned to live in Turkey at retirement after fifteen years as Hamburg University’s Ordinarius professor following the war."), _c('sup', {
    staticClass: "sup"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/28_Notes#ch4fn43",
      "id": "rch4fn43",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("43")])]), _vm._v(" Fortunately, for Turkey’s "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Üniversite Reformu")]), _vm._v(" and the intellectual ferment it created, Kosswig was accompanied in his work by other life scientists.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Botanist "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Gustav Gassner,")]), _vm._v(" one of the pioneers of wood science, was professor of botany at the Braunschweig Technical "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Hochschule")]), _vm._v(" (today Technical University). In 1932, elected its rector, he became involved in a conflict between the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Hochschule")]), _vm._v(" and Braunschweig’s provincial administration that, starting 1930/1931, was already in Nazi Party hands. This was about two years before Hitler’s seizure of power in January 1933. In March of 1932, the local Nazi government dismissed Gassner"), _c('sup', {
    staticClass: "sup"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/28_Notes#ch4fn44",
      "id": "rch4fn44",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("44")])]), _vm._v(" from rectorship and imprisoned him for 11 days. On September 30 1933, this was followed with dismissal as professor of botany."), _c('sup', {
    staticClass: "sup"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/28_Notes#ch4fn45",
      "id": "rch4fn45",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("45")])]), _vm._v(" Between 1934 and 1939, Gassner served as one of the émigré professors at Ankara University and as director of plant preservation in the government’s agriculture department. He was an acknowledged expert and scientist. His book, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Microscopic Examinations of Plant Food")]), _vm._v(" was republished in 1989."), _c('sup', {
    staticClass: "sup"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/28_Notes#ch4fn46",
      "id": "rch4fn46",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("46")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Gassner’s return to Germany in 1939 had been facilitated by a Gestapo clearance. As a matter of significance to be explored later, after returning, he published a scientific paper. His scientific collaborator and coauthor during the midst of the war was "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Dr. Friedrich (Fritz) Christiansen-Weniger")]), _vm._v(" a German agricultural scientist who worked in Ankara for roughly seven years. After much deliberation, Germany’s embassy in Ankara cleared his return as well. Christiansen-Weniger left Turkey in 1940 to take up a research and consulting position in Nazi-occupied Poland.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Gustav Gassner was also a close friend and colleague of zoologist Curt Kosswig."), _c('sup', {
    staticClass: "sup"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/28_Notes#ch4fn47",
      "id": "rch4fn47",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("47")])]), _vm._v(" Soon after émigré zoologist "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Andre Neville’s")]), _vm._v(" death of typhus on April 1 1937, Prof. Dr. Curt Kosswig was appointed Professor of Zoology in the fall of 1937. Although not particularly happy with Germany’s political climate, Kosswig was not among those who had to leave or die. There is reason to suspect that Kosswig"), _c('sup', {
    staticClass: "sup"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/28_Notes#ch4fn48",
      "id": "rch4fn48",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("48")])]), _vm._v(" heard about the position having been opened or was offered this position while still in Braunschweig. Was Gassner instrumental? Although there is no definitive answer to that question, circumstantial archival evidence suggests such to be the case ("), _c('a', {
    attrs: {
      "href": "#/xhtml/12_Chapter04#fig_26"
    }
  }, [_vm._v("Fig. 26")]), _vm._v(").")]), _vm._v(" "), _c('p', {
    staticClass: "indenttb"
  }, [_c('a', {
    attrs: {
      "id": "page_79"
    }
  }), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Alfred Heilbron")]), _vm._v(" founded modern botanies in Turkey."), _c('sup', {
    staticClass: "sup"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/28_Notes#ch4fn49",
      "id": "rch4fn49",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("49")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Professor Heilbron was born in Furth, Bavaria, in 1885. Starting as a Dozent at the University of Münster in 1912, he was promoted to Professor of Botany in 1919. Between 1919 and 1933, he also served as Director of the Münster "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Farmabotanik")]), _vm._v(" Institute. With wife and three children, Heilbronn came to Turkey in the first wave of German émigré professors.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Professor Heilbron was forced to take refuge in Switzerland with his colleagues "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Leo Brauner")]), _vm._v(" and "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Andre Neville.")]), _vm._v(" These valuable scientists came to Istanbul in October 1933 on Atatürk’s personal invitation. They started to give courses in botany and zoology in the Biology Institute as the school was then called. From the first day he started lecturing in Istanbul, Heilbron hoped to establish a botanical garden under University auspices. The construction of the Institute building was started in 1934 on the campus of the Istanbul Girls High School that belonged to the Istanbul "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Müftülügü")]), _vm._v(" (Directorate of Religious Affairs) and Heilbron was assigned the job to found its botanical garden. He was supported in this effort by German garden specialists "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Leo Brauner")]), _vm._v(" and "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Walter Stephan.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Founded in 1973, and starting with a Faculty of Agriculture, the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Cukurova")]), _vm._v(" University in Adana, Turkey, maintains a website discussing all aspects of plant science. Referring to the above émigrés, the site states, “these three men and their entourage worked in such a systematic and disciplined manner that the botanical garden was ready to be opened in the spring of 1936. Another great attainment of these three is the first seed catalogue of the botanical garden published in 1935.” The site goes on to point out that “this first seed catalogue of the Istanbul University Plant Garden "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("(Hortus Botanicus Istanbuensis: Index Seminum),")]), _vm._v(" simple yet very valuable, includes an introduction by "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("A. Heilbron, L. Brauner,")]), _vm._v(" and Garden Specialist "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("W. Stephan")]), _vm._v(" describing the objectives of the garden. The first attempt to set up a botanical garden in Turkey was in about 1949 with the establishment of an Arboretum in Bahçeköy near Istanbul with the support of the University of Istanbul Faculty of Forestry.” However, the site laments the fact that “in spite of the rich biodiversity and high number of species both in flora and fauna in Turkey, the number of botanical gardens are [still] quite few.”"), _c('sup', {
    staticClass: "sup"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/28_Notes#ch4fn50",
      "id": "rch4fn50",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("50")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Botanist "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Ludwig Schnee")]), _vm._v(" who was born in 1908 was also part of the life-science team in Turkey between 1933 and 1938 after being discharged from the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Universität Köln.")]), _vm._v(" Both he and his wife worked in the Institut for Pharmabotaniks and Genetics at the University of Istanbul. They left Turkey for Venezuela in 1938.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("On arrival at the University of Istanbul in 1933, after being discharged as Professor of Botany from "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Jena")]), _vm._v(" University, Leo Brauner became professor "), _c('a', {
    attrs: {
      "id": "page_80"
    }
  }), _vm._v("of Botany and first Director of the Botanical Physiology Institute.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("In addition to inviting those who needed a safe haven from the Nazis during the prewar period, Turkey also invited German-Jewish scholars who were settled elsewhere. "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Frederick Simon Bodenheimer")]), _vm._v(" was brought in from the Hebrew University of Jerusalem. “While serving as visiting professor and founder of the department of agricultural entomology at the University of Ankara, he [Bodenheimer] wrote four textbooks that were translated and published in the Turkish language: two on entomology, one in zoology, and one in beekeeping, plus a surprise bonus in the form of a fifth book in Hebrew on Turkish folk art.”"), _c('sup', {
    staticClass: "sup"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/28_Notes#ch4fn51",
      "id": "rch4fn51",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("51")])]), _vm._v(" Bodenheimer brought to Turkey his experience of writing modern scientific textbooks in an ancient language.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("In an article that appeared in the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Annual Review of Entomology,")]), _vm._v(" after noting that the Hebrew language was revived as a spoken language for everyday secular usage only at the beginning of the twentieth century, Professor Isaac Harpaz points out that “it was desperately lacking modern scientific terminology, let alone suitable updated textbooks for higher education.” Harpaz continues by stating that, “Bodenheimer had to compile such textbooks in zoology, entomology, and the history of biology first in German and later in English, while others had to help translate the manuscripts to Hebrew. However, all these enormous obstacles were overcome by enthusiastic efforts of both students and teachers.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Recalling that only a few years had passed since Turkey converted its alphabet from Arabic, many symbols and scientific terms having Turkish roots needed to be invented. This was certainly the case in all discussions involving chemistry and biochemistry. Thus Bodenheimer’s experience in what was then Palestine was invaluable to these efforts. Having completed his work in Turkey, Bodenheimer returned to his beloved Hebrew University of Jerusalem and continued to make major contributions to knowledge and to educating new cadres. “Of the forty M.Sc. and Ph.D. theses that were carried out under his supervision during 1934-1959, the majority were on subjects with significant practical implications for crop protection, public heath, animal husbandry, and apiculture.”"), _c('sup', {
    staticClass: "sup"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/28_Notes#ch4fn52",
      "id": "rch4fn52",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("52")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The following extract from an obituary to a first-generation émigré professor’s trained Turkish scientist speaks to the enduring national pride in the legacy these life science professors left behind:")]), _vm._v(" "), _c('div', {
    staticClass: "quote"
  }, [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("Prof. Dr. Muhtar BASOGLU, the first Turkish scientific herpetologist, was born in 1913 at Odemis near Izmir. In 1932, he enrolled, and, in 1936, he graduated from the Natural Sciences Section of Istanbul University’s Science Faculty, where, he was appointed as Assistant in 1941 after completing his military service. There, based on his thesis “Sur le métabolisme de la "), _c('a', {
    attrs: {
      "id": "page_81"
    }
  }), _vm._v("corde nerveuse du ver de terre,” Basoglu was promoted to Doctor of Zoology.... He was guided by the German Professor Curt Kosswig, who, at that time, was teaching at Istanbul University. In 1946, Basoglu translated Bodenheimer’s Introduction to the knowledge of Amphibia and Reptilia of Turkey (1944), into Turkish. Thereafter Basoglu became an engaged herpetologist, and his publication “Experiments on the composition of the alveolar air in Testudo graeca and Clemmys rivulata” helped him become associate professor.... During all these years his research work was devoted to herpetology, and, together with six doctors of zoology, raised by Basoglu himself, he founded and organized the first “Turkish Herpetological Centre” at Ege University. This Institute has brought together a large and comprehensive herpetological collection of more than 20,000 specimens, including material of every taxon of amphibians and reptiles living in Turkey. Since then, one of the above mentioned six doctors was appointed to the Istanbul University (now retired), the other five have become full professors, one of which is now at the 9 Eylül University, the remaining four are still with the Biology Department of the Science Faculty, Ege University.... During his last 20 years, Professor Dr. Muhtar Basoglu and his team studied the herpetofauna of Turkey, and, summing up the results of these concentrated efforts, he published three books.... Thus the untimely death of Professor Dr. Muhtar Basoglu on February 21st, 1981 ended the career of an outstanding herpetologist and distinguished teacher, whose lifelong ideal was to raise and form a group of zoologists, willing and able to efficiently carry out scientific work in the “Turkish Herpetological Centre” that he himself founded."), _c('sup', {
    staticClass: "sup"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/28_Notes#ch4fn53",
      "id": "rch4fn53",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("53")])]), _vm._v(" (emphasis added).")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("According to its most recent posting on the Web, this is what the University of Istanbul has to say about the legacy left behind by the long-gone émigrés:"), _c('sup', {
    staticClass: "sup"
  }, [_vm._v("54")])]), _vm._v(" "), _c('div', {
    staticClass: "quote"
  }, [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("The Department of Biology at Istanbul University teaches joint courses in biology, for a three-year period after which, in their fourth year, the students select, according to their fields of interest, one of the seven proposed package programs and take their first steps towards specialization. Research on the subjects such as flora-fauna systematic, morphology, ecology, cytology, histology, physiology, microbiology, radiobiology, hydrobiology, molecular biology, genetics, and biochemistry is undertaken in "), _c('a', {
    attrs: {
      "id": "page_82"
    }
  }), _vm._v("well-equipped laboratories, with facilities like the latest appliances and electron microscopes. Some of the work is done through international cooperation and some through projects sponsored by national institutions. The department has a Botanical Garden and an Herbarium, a Zoology Museum and a Hydrobiology Museum used for research purposes.")])]), _vm._v(" "), _c('div', {
    staticClass: "img_container",
    attrs: {
      "id": "fig_22"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_83"
    }
  }), _c('img', {
    attrs: {
      "alt": "image",
      "src": "images/f0083-01.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "cap"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Figure 22")])]), _vm._v(" "), _c('p', {
    staticClass: "cap1"
  }, [_vm._v("Istanbul Archeological Museum.")])]), _vm._v(" "), _c('div', {
    staticClass: "img_container",
    attrs: {
      "id": "fig_23"
    }
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/f0083-02.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "cap"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Figure 23")])]), _vm._v(" "), _c('p', {
    staticClass: "cap1"
  }, [_vm._v("Georg Rohde (1899-1960).")])]), _vm._v(" "), _c('div', {
    staticClass: "img_container",
    attrs: {
      "id": "fig_24"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_84"
    }
  }), _c('img', {
    attrs: {
      "alt": "image",
      "src": "images/f0084-01.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "cap"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Figure 24")])]), _vm._v(" "), _c('p', {
    staticClass: "cap1"
  }, [_vm._v("Manyas Lake.")])]), _vm._v(" "), _c('div', {
    staticClass: "img_container",
    attrs: {
      "id": "fig_25"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_85"
    }
  }), _c('img', {
    attrs: {
      "alt": "image",
      "src": "images/f0085-01.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "cap"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Figure 25")])]), _vm._v(" "), _c('p', {
    staticClass: "cap1"
  }, [_vm._v("Bald ibis.")])]), _vm._v(" "), _c('div', {
    staticClass: "img_container",
    attrs: {
      "id": "fig_26"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_86"
    }
  }), _c('img', {
    attrs: {
      "alt": "image",
      "src": "images/f0086-01.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "cap"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Figure 26")])]), _vm._v(" "), _c('p', {
    staticClass: "cap1"
  }, [_vm._v("September 14 1937. Letter from Faculty of Medicine Dean to the university’s Rector calling a faculty committee meeting to choose Professor Neville’s replacement. Kosswig is recommended.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-ab1ca654","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/12_Chapter04.vue
// module id = 102
// module chunks = 0